import SearchResults from "./Components/SearchResults";

/**
 * @namespace GlobalSearch
 */

const Search = () => <SearchResults />;

export default Search;
